import { loadScript } from 'trackers/helper'

function createCrispQueue(): Window['$crisp'] {
  return Object.assign([] as unknown[][], {
    get: () => null,
    set: () => undefined,
  }) as Window['$crisp']
}

function isStonlySessionFieldRead(error: unknown, args: unknown[]): boolean {
  return (
    error instanceof TypeError &&
    args[0] === 'session:data' &&
    args[1] === 'stonlyWidgetRuleId'
  )
}

function installSafeSessionGetter(): void {
  const crisp = window.$crisp
  if (!crisp?.get) return

  const get = crisp.get.bind(crisp)
  crisp.get = (...args: unknown[]) => {
    try {
      return get(...args)
    } catch (error) {
      if (isStonlySessionFieldRead(error, args)) return null
      throw error
    }
  }
}

export async function initCrisp(): Promise<void> {
  const websiteId = import.meta.env.VITE_CRISP_WEBSITE_ID
  if (!websiteId) return

  window.$crisp = createCrispQueue()
  window.CRISP_WEBSITE_ID = websiteId
  installSafeSessionGetter()
  await loadScript('https://client.crisp.chat/l.js')
  installSafeSessionGetter()
}

export function loginCrisp(
  email: string,
  firstName: string,
  lastName: string,
): void {
  if (window.$crisp) {
    window.$crisp.push(['set', 'user:email', [email]])
    window.$crisp.push(['set', 'user:nickname', [`${firstName} ${lastName}`]])
  }
}

export function openCrispChatWithMessage(message: string): void {
  if (!window.$crisp) return

  window.$crisp.push(['set', 'message:text', [message]])
  window.$crisp.push(['do', 'chat:show'])
  window.$crisp.push(['do', 'chat:open'])
}
